import { render, staticRenderFns } from "./contenitoreEmpty.vue?vue&type=template&id=3acc0f7a&"
import script from "./contenitoreEmpty.vue.ts?vue&type=script&lang=ts&"
export * from "./contenitoreEmpty.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports